import { useState } from 'react';
import { Alert, Button, Text, TextInput } from '@gravity-ui/uikit';
import { useSessionStore } from '../../lib/session/context.js';
import { Field } from '../../ui/field.js';

/**
 * «Забыли пароль?» в админке платформы: ссылка уходит на почту сотрудника.
 * Меняет только пароль — код из приложения-аутентификатора остаётся прежним,
 * и вход после смены всё равно его спросит.
 */
export function ForgotPasswordForm({ initialEmail, onBack }: { initialEmail: string; onBack: () => void }) {
  const store = useSessionStore();
  const [email, setEmail] = useState(initialEmail);
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [problem, setProblem] = useState<string | null>(null);

  async function submit(): Promise<void> {
    setBusy(true);
    setProblem(null);
    try {
      await store.requestPasswordReset(email.trim());
      setSent(true);
    } catch (error) {
      setProblem(error instanceof Error ? error.message : 'Письмо не отправлено. Проверьте связь и повторите');
    } finally {
      setBusy(false);
    }
  }

  if (sent) {
    return (
      <div className="flex flex-col gap-4">
        <Alert
          theme="success"
          message={`Если ${email.trim()} — адрес сотрудника платформы, на него придёт письмо со ссылкой. Ссылка действует час; код из приложения-аутентификатора не меняется.`}
        />
        <Button view="action" size="l" width="max" onClick={onBack}>
          Вернуться ко входу
        </Button>
      </div>
    );
  }

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        void submit();
      }}
      className="flex flex-col gap-4"
    >
      <Text color="secondary">Пришлём на почту ссылку, по которой можно задать новый пароль.</Text>
      <Field label="Почта" required>
        {(id) => (
          <TextInput id={id} size="l" type="email" name="email" autoComplete="username" value={email} onUpdate={setEmail} autoFocus />
        )}
      </Field>
      {problem === null ? null : <Alert theme="danger" message={problem} />}
      <div className="flex flex-col gap-2">
        <Button type="submit" view="action" size="l" width="max" loading={busy} disabled={email.trim() === ''}>
          Прислать ссылку
        </Button>
        <Button type="button" view="flat-secondary" size="l" width="max" disabled={busy} onClick={onBack}>
          Назад ко входу
        </Button>
      </div>
    </form>
  );
}
